export type DetectionMode = 'manual' | 'automatic' | '';

export interface AtsJobStage {
  id: number;
  name: string;
  ats_job_milestone?: { name: string };
}

export interface StageOption {
  value: number | null;
  label: string;
}

export interface EmailTemplate {
  id: number;
  name: string;
  body?: string;
  subject?: string;
  from?: string;
  cc?: string[];
  bcc?: string[];
  attachments?: unknown[];
}

export interface FraudDetectorDrawerFormProps {
  formRef: React.RefObject<any>;
  initialValues: FraudDetectorFormValues;
  onSubmit: () => void;
  onValuesChange?: (_values: FraudDetectorFormValues) => void;
  jobId: string | number;
}

export interface FraudDetectorFormValues {
  detection_mode: DetectionMode;
  contact_background_verification_preferred_ats_job_stage_id: number | null;
  auto_reject_enabled: boolean;
  ats_rejection_reason_id: number | null;
  sendRejectEmail: boolean;
  selectedTemplate: Record<string, unknown> | null;
  from: string;
  fromUserObject: Record<string, unknown> | null;
  subject: string;
  body: string;
  cc: string[];
  bcc: string[];
  attachments: unknown[];
  scheduleEmail: boolean;
  sendAfter: number;
  scheduleTime: string | null;
  scheduleTimezone: unknown;
  survey: unknown;
}

export interface ExistingCandidatesPopupData {
  show_existing_candidate_popup: true;
  candidate_count: number;
  criteria_count: number;
  default_stage_bulk_run_enabled: boolean;
  stageName?: string;
}

export function isExistingCandidatesPopup(
  data: unknown
): data is ExistingCandidatesPopupData {
  return (
    typeof data === 'object' &&
    data !== null &&
    (data as ExistingCandidatesPopupData).show_existing_candidate_popup === true
  );
}

export const FRAUD_DETECTOR_FORM_DEFAULTS: FraudDetectorFormValues = {
  detection_mode: '',
  contact_background_verification_preferred_ats_job_stage_id: null,
  auto_reject_enabled: false,
  ats_rejection_reason_id: null,
  sendRejectEmail: false,
  selectedTemplate: null,
  from: '',
  fromUserObject: null,
  subject: '',
  body: '',
  cc: [],
  bcc: [],
  attachments: [],
  scheduleEmail: true,
  sendAfter: 1,
  scheduleTime: null,
  scheduleTimezone: null,
  survey: null,
};
